import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  offers: {
    id: 'offers',
    defaultMessage: 'Offers',
    description: 'Text link that takes the user to our current offers page'
  },

  restaurants: {
    id: 'restaurants',
    defaultMessage: 'Restaurants',
    description: 'Text link that takes the user to our restaurants page'
  },

  catering: {
    id: 'catering',
    defaultMessage: 'Catering',
    description: 'Text link that takes the user to catering page'
  },

  menu: {
    id: 'menu',
    defaultMessage: 'Menu',
    description: 'Text link that takes the user to menu'
  },

  order: {
    id: 'order',
    defaultMessage: 'Order',
    description: 'Text link that takes the user to their current order'
  }
});
